<template>
  <div class="page flex-col">
    <div class="bd1 flex-col">
      <div class="mod1 flex-col">
        <div class="bd2 flex-col">
          <!-- 头部导航栏 -->
          <div class="outer2 flex-row">
            <!-- <img
              @click="back"
              class="label2"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng055f7822a065d24838fe4f8316b496c62564a3c880241121ac9014c59d7218c3"
            />
            <span class="word3">注册</span>-->
            <!-- <span class="info1" @click="onMore" v-if="this.more!=0">更多操作</span>  -->
            <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
            <div>我的钱包</div>
            <div></div>
<!--            <div @click="onMore" v-if="this.more!=0">更多操作</div>-->
<!--            <div v-else></div>-->
          </div>
          <!-- <div class="register-top">

          </div> -->
          <!-- 头部图片 -->
          <div class="outer3"></div>
        </div>
        <div class="bd3 flex-col">
          <div class="wrap1 flex-col">
            <span class="txt2"><b>开始实名认证</b></span>
            <div class="box1 flex-row">
              <div class="bd4 flex-col"></div>
              <span class="paragraph1">
                为保证您的款项及时发放
                <br />
                请尽快完成
              </span>
            </div>
          </div>
        </div>
      </div>
      <button class="mod2 flex-col" @click="onClick_1"  v-if="this.more!=0">
        <span class="word4">立即开始</span>
      </button>
      <button class="mod2 flex-col" disabled v-if="this.more==0">
        <span class="word4">已实名</span>
      </button>
      <div class="mod3 flex-row">
        <!-- 复选框按钮 -->
        <!-- <nut-checkbox v-model="checkbox1"> </nut-checkbox>
        <span class="txt3">阅读并同意</span>
        <span class="word5">《自由职业者服务框架协议》</span> -->
      </div>
      <div class="mod4 flex-row">
        <img
          class="pic2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2aabae92ffd65a635e10c5428c8fee67fc262b0b0e8bd9b27129bf33ca8fb777"
        />
        <span class="info2">我的专享特权</span>
        <img
          class="img2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6ba51222b9d482fc2173fb00caf1e0f6296021131b1201404c95e6996317b3ce"
        />
      </div>
      <div class="mod5 flex-col">
        <div class="bd5 flex-row">
          <div class="bd6 flex-col">
            <div class="flex-col">
              <img
                class="icon3"
                referrerpolicy="no-referrer"
                src="../../assets/img/dredge/dredge-manage.png"
              />
            </div>
          </div>
          <div class="bd7 flex-col">
            <div class="info3">账户管理</div>
            <div class="word6">随时随地进行收入管理、流水明细查询</div>
          </div>
        </div>
      </div>
      <div class="mod6 flex-col">
        <div class="bd8 flex-row">
          <div class="flex-col">
            <img
              class="layer1"
              referrerpolicy="no-referrer"
              src="../../assets/img/dredge/dredge-into.png"
            />
          </div>
          <div class="section2 flex-col">
            <div class="word7">提现秒到账</div>
            <div class="txt4">经营收入提现0手续费、提现秒级到账</div>
          </div>
        </div>
      </div>
      <div class="mod7 flex-col">
        <div class="wrap2 flex-row">
          <div class="flex-col">
            <img
              class="mod8"
              referrerpolicy="no-referrer"
              src="../../assets/img/dredge/dredge-safe.png"
            />
          </div>
          <div class="group2 flex-col">
            <div class="txt5">安全有保障</div>
            <div class="info4">由平安银行提供资金安全保障</div>
          </div>
        </div>
      </div>
      <div class="mod9 flex-col">
        <div class="outer5 flex-row">
          <div class="flex-col">
            <img
              class="layer2"
              referrerpolicy="no-referrer"
              src="../../assets/img/dredge/dredge-nigger.png"
            />
          </div>
          <div class="box3 flex-col">
            <div class="word8">保护客户隐私</div>
            <div class="paragraph2">
              客户信息隐私保护，权威金融机构资料认证，
              <br />
              信息加密传输；
            </div>
          </div>
        </div>
      </div>
      <div class="mod10 flex-col">
        <div class="box4 flex-row">
          <div class="flex-col">
            <img
              class="bd9"
              referrerpolicy="no-referrer"
              src="../../assets/img/dredge/dredge-settle.png"
            />
          </div>
          <div class="outer7 flex-col">
            <div class="word9">记录结算数据</div>
            <div class="word10">历史收入结算查询</div>
          </div>
        </div>
      </div>
      <div class="mod11 flex-col">
        <div class="block1 flex-row">
          <div class="flex-col">
            <img
              class="block2"
              referrerpolicy="no-referrer"
              src="../../assets/img/dredge/dredge-tax.png"
            />
          </div>
          <div class="bd11 flex-col">
            <div class="word11">合法个税</div>
            <div class="word12">个人税务资料登记，合法合规</div>
          </div>
        </div>
      </div>
      <!-- <span class="txt6" @click="back">稍后再说</span> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {},
      // 复选框按钮
      checkbox1: false,
      taskNo:"",
      more:"",
    };

  },
  mounted(){
    const url = new URL(location.href);
    this.more = url.searchParams.get('more');
  },
  methods: {
    // 返回上一层
    back() {
      this.$router.go(-1); //返回上一层
    },
    goBack(){
      this.$router.go(-1);
    },
    onClick_1() {
      // this.$router.push({path:"/commonInfo",query:{type:2}}) // 取消二类户开通入口
      this.$router.push({path:"/commonInfo",query:{type: 1}})
    },
    onMore(){
      this.$router.push({path:"/moreInfo"})

    }
  },
};
</script>
<style>
/* 是否同意协议按钮 */
.nut-checkbox input:checked {
  background-color: #0580fc;
  color: #fff;
  border-radius: 50%;
  border: 1px solid #0580fc;
}
.nut-checkbox input::after {
  background: none;
}
.nut-checkbox input {
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #0580fc;
  color: #fff;
}
</style>
<style lang="less">
body * {
  box-sizing: border-box;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
  button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
    &:active {
      opacity: 0.6;
    }
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
}
</style>
<style lang="less" scoped>
.page {
  z-index: 1;
  position: relative;
  width: 750px;
  height: auto;
  background-color: rgba(248, 248, 250, 1);
  overflow: hidden;
  justify-content: flex-start;
  .bd1 {
    z-index: auto;
    width: 750px;
    height: auto;
    .mod1 {
      z-index: 3;
      height: 420px;
      width: 750px;
      .bd2 {
        z-index: auto;
        width: 750px;
        height: 100%;
        .outer2 {
          background: #033188;
          box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.22);
          border-bottom: 1px solid #033188;
          z-index: auto;
          padding-top: 20px;
          display: flex;
          justify-content: space-between;
          color: #ffffff;
          padding: 20px;
          font-size: 35px;
          .jian{
            font-size: 35px;
          }
          .label2 {
            z-index: 32;
            width: 16px;
            height: 27px;
            margin-top: 10px;
            margin-left: 45px;
          }

          .word3 {
            z-index: 31;
            width: 64px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 32px;
            font-family: PingFangSC-Medium;
            line-height: 45px;
            text-align: center;
            margin-left: 260px;
          }
          .info1 {
            z-index: 34;
            // width: 120px;
            display: block;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 30px;
            line-height: 42px;
            text-align: left;
            margin: 2px 0 0 193px;
          }
        }
        .register-top{
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: transparent;
        }
        .outer3 {
          z-index: 4;
          height: 440px;
          background: url("../../assets/img/dredge/dredge-header.png") no-repeat;
          align-self: center;
          width: 100%;
          background-size: 100% 90%;
          justify-content: flex-start;
          align-items: flex-end;
        }
      }
      .bd3 {
        z-index: 6;
        height: 303px;
        background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4849a9376808c030b1bd355be57a120c7a5c43cdb0a24af2aace764d22286dd2)
          100% no-repeat;
        width: 651px;
        justify-content: flex-end;
        align-items: flex-start;
        position: absolute;
        left: 50px;
        top: 137px;
        padding: 0 0 74px 35px;
        .wrap1 {
          z-index: auto;
          width: 448px;
          height: 146px;
          .txt2 {
            z-index: 7;
            width: 460px;
            display: block;
            margin-top: -80px;
            margin-bottom: 20px;
            overflow-wrap: break-word;
            color: rgba(84, 54, 27, 1);
            font-size: 32px;
            font-family: PingFangSC-Medium;
            line-height: 50px;
            text-align: left;
            align-self: center;
            .box1 {
              z-index: auto;
              width: 304px;
              height: 74px;
              margin-top: 27px;
              justify-content: space-between;
            }
          }
        }
      }
      .bd4 {
        z-index: 9;
        width: 8px;
        height: 8px;
        background-color: rgba(84, 54, 27, 1);
        margin-top: 15px;
        margin-right: 10px;
      }
      .paragraph1 {
        z-index: 8;
        width: 286px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(84, 54, 27, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
      }
    }

    .mod2 {
      z-index: 105;
      height: 90px;
      border-radius: 45px;
      // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4ba68295ce88d3ea8387f4f9197214ff3f04a3fd100f5ef03bfa50979df64c06)
        // 100% no-repeat;
        background: #dfba85;
      align-self: center;
      margin-top: 50px;
      width: 638px;
      justify-content: center;
      align-items: center;
      .word4 {
        z-index: 106;
        width: 140px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(95, 61, 16, 1);
        font-size: 34px;
        letter-spacing: 1px;
        font-family: PingFangSC-Medium;
        line-height: 48px;
        text-align: center;
        width: 100%;
      }
    }
    .mod3 {
      z-index: auto;
      width: 60%;
      height: 30px;
      margin: 20px 0 0 162px;
      .icon2 {
        z-index: 109;
        width: 20px;
        height: 20px;
        margin-top: 5px;
      }

      .txt3 {
        z-index: 108;
        width: 140px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(142, 142, 142, 1);
        font-size: 22px;
        line-height: 30px;
        text-align: left;
        margin-left: 10px;
      }

      .word5 {
        z-index: 112;
        width: 286px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(48, 131, 255, 1);
        font-size: 22px;
        font-family: PingFangSC-Medium;
        line-height: 30px;
        text-align: left;
      }
    }
    .mod4 {
      z-index: auto;
      width: 348px;
      height: 45px;
      justify-content: space-between;
      margin: 50px 0 0 201px;
      .pic2 {
        z-index: 98;
        width: 58px;
        height: 9px;
        margin-top: 20px;
      }

      .info2 {
        z-index: 97;
        // width: 192px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        font-family: PingFangSC-Medium;
        line-height: 45px;
        text-align: left;
      }

      .img2 {
        z-index: 101;
        width: 58px;
        height: 9px;
        margin-top: 20px;
      }
    }
    .mod5 {
      z-index: 36;
      height: 160px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      align-self: center;
      margin-top: 20px;
      width: 700px;
      justify-content: center;
      align-items: flex-start;
      padding-left: 30px;
      .bd5 {
        z-index: auto;
        width: 563px;
        height: 97px;
        justify-content: space-between;
      }

      .bd6 {
        z-index: 38;
        height: 97px;
        border-radius: 50%;
        background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnged42933c27c52275d465dab5b1496984ebac370150ecfd32cca39cea83cd9ed7)
          100% no-repeat;
        width: 97px;
        justify-content: center;
        align-items: center;
      }

      .icon3 {
        z-index: 40;
        width: 97px;
        height: 97px;
      }

      .bd7 {
        z-index: auto;
        width: 442px;
        height: 86px;
        margin-top: 5px;
      }

      .info3 {
        z-index: 42;
        // width: 128px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        line-height: 45px;
        text-align: left;
        align-self: flex-start;
      }

      .word6 {
        z-index: 41;
        // width: 442px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        align-self: center;
        margin-top: 4px;
      }
    }
    .mod6 {
      z-index: 44;
      height: 160px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      align-self: center;
      margin-top: 20px;
      width: 700px;
      justify-content: center;
      align-items: flex-start;
      padding-left: 30px;

      .bd8 {
        z-index: auto;
        width: 553px;
        height: 97px;
        justify-content: space-between;
      }
      .layer1 {
        z-index: 47;
        width: 97px;
        height: 97px;
      }

      .section2 {
        z-index: auto;
        width: 432px;
        height: 86px;
        margin-top: 5px;
      }

      .word7 {
        z-index: 54;
        // width: 160px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        line-height: 45px;
        text-align: left;
        align-self: flex-start;
      }

      .txt4 {
        z-index: 53;
        // width: 432px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        align-self: center;
        margin-top: 4px;
      }
    }
    .mod7 {
      z-index: 56;
      height: 160px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      align-self: center;
      margin-top: 20px;
      width: 700px;
      justify-content: center;
      align-items: flex-start;
      padding-left: 30px;
      .wrap2 {
        z-index: auto;
        width: 459px;
        height: 97px;
        justify-content: space-between;
      }

      .mod8 {
        z-index: 59;
        width: 97px;
        height: 97px;
      }

      .group2 {
        z-index: auto;
        width: 338px;
        height: 86px;
        margin-top: 5px;
      }

      .txt5 {
        z-index: 65;
        // width: 160px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        line-height: 45px;
        text-align: left;
        align-self: flex-start;
      }

      .info4 {
        z-index: 64;
        width: 338px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        align-self: center;
        margin-top: 4px;
      }
    }
    .mod9 {
      z-index: 79;
      height: 190px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      align-self: center;
      margin-top: 20px;
      width: 700px;
      justify-content: center;
      align-items: center;
      .outer5 {
        z-index: auto;
        width: 641px;
        height: 128px;
        justify-content: space-between;
      }

      .layer2 {
        z-index: 82;
        width: 97px;
        height: 97px;
      }

      .box3 {
        z-index: auto;
        width: 520px;
        height: 123px;
        margin-top: 5px;
      }

      .word8 {
        z-index: 87;
        // width: 192px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        line-height: 45px;
        text-align: left;
        align-self: flex-start;
      }

      .paragraph2 {
        z-index: 86;
        width: 520px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        align-self: center;
        margin-top: 4px;
      }
    }
    .mod10 {
      z-index: 67;
      height: 160px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      align-self: center;
      margin-top: 20px;
      width: 700px;
      justify-content: center;
      align-items: flex-start;
      padding-left: 30px;
      .box4 {
        z-index: auto;
        width: 329px;
        height: 97px;
        justify-content: space-between;
      }

      .bd9 {
        z-index: 70;
        width: 97px;
        height: 97px;
      }

      .outer7 {
        z-index: auto;
        width: 208px;
        height: 86px;
        margin-top: 5px;
      }

      .word9 {
        z-index: 77;
        // width: 192px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        line-height: 45px;
        text-align: left;
        align-self: flex-start;
      }

      .word10 {
        z-index: 76;
        width: 208px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        align-self: center;
        margin-top: 4px;
      }
    }
    .mod11 {
      z-index: 89;
      height: 160px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      align-self: center;
      margin-top: 20px;
      width: 700px;
      justify-content: center;
      align-items: flex-start;
      padding-left: 30px;
      .block1 {
        z-index: auto;
        width: 459px;
        height: 97px;
        justify-content: space-between;
      }

      .block2 {
        z-index: 92;
        width: 97px;
        height: 97px;
      }

      .bd11 {
        z-index: auto;
        width: 338px;
        height: 86px;
        margin-top: 5px;
      }

      .word11 {
        z-index: 96;
        // width: 128px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(34, 34, 34, 1);
        font-size: 32px;
        line-height: 45px;
        text-align: left;
        align-self: flex-start;
      }

      .word12 {
        z-index: 95;
        width: 338px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        align-self: center;
        margin-top: 4px;
      }
    }
    // 稍后再说
    .txt6 {
      z-index: 113;
      width: 104px;
      display: block;
      overflow-wrap: break-word;
      color: rgba(102, 102, 102, 1);
      font-size: 26px;
      line-height: 37px;
      text-align: left;
      align-self: center;
      margin-top: 30px;
      padding-bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/register/index.vue